<div class="login-wrap">
  <button class="login-back" [routerLink]="['/inicio']" aria-label="Volver">
    <mat-icon>arrow_back</mat-icon>
  </button>

  <div class="login-card">
    <div class="login-card-top">
      <img src="./assets/images/Augajo/augajoblanco.avif" alt="Inversiones Augajo" class="card-logo">
    </div>

    <div class="login-card-body">
      <h1>Iniciar sesión</h1>
      <p class="login-sub">Ingresa tus credenciales para continuar</p>

      <form [formGroup]="formLogin" (ngSubmit)="login()">

        <div class="campo">
          <label>{{ textoInput }}</label>
          <div class="campo-input">
            <input type="text" [placeholder]="textoInput" formControlName="usuario" autocomplete="off" required>
          </div>
          @if (formLogin.get('usuario').invalid && formLogin.get('usuario').touched) {
          <span class="campo-error">El {{ textoInput }} es requerido</span>
          }
        </div>

        @if (tipoLogueo === 'admin') {
        <div class="campo">
          <label>Contraseña</label>
          <div class="campo-input">
            <input [type]="hide ? 'password' : 'text'" placeholder="Ingresa tu contraseña" formControlName="clave"
              autocomplete="off">
            <button type="button" class="toggle-pass" (click)="hide = !hide" aria-label="Mostrar contraseña">
              <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </div>
          @if (formLogin.get('clave').invalid && formLogin.get('clave').touched) {
          <span class="campo-error">La contraseña es requerida</span>
          }
        </div>
        }

        @if (!(authService.responseCargando$ | async)?.loading) {
        <button type="submit" class="btn-login">Ingresar</button>
        }

        @if ((authService.responseCargando$ | async)?.loading) {
        <div class="login-spinner">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
        }

      
      </form>
    </div>
  </div>

  <div class="login-foot">© 2026, Inversiones Augajo · Todos los derechos reservados</div>
</div>